( function ( $ ) {
    $(window).load(function() {
        $('#page').removeClass('preload');
    });
})(jQuery);